import api from './api';

/**
 * Support Service
 * API calls for support ticket functionality
 */
const supportService = {
  /**
   * Create a new support ticket
   * @param {Object} data - Ticket data
   * @param {string} data.category - 'technical', 'billing', 'general', 'feedback'
   * @param {string} data.subject - Ticket subject
   * @param {string} data.message - Ticket message
   */
  createTicket: (data) => api.post('/support', data),

  /**
   * Get current user's support tickets
   * @param {Object} params - Query parameters
   * @param {number} params.limit - Max tickets to return
   * @param {number} params.offset - Offset for pagination
   */
  getMyTickets: (params = {}) => api.get('/support', { params }),

  /**
   * Get single ticket by ID
   * @param {number} id - Ticket ID
   */
  getTicket: (id) => api.get(`/support/${id}`)
};

export default supportService;
